import type { SVGProps } from "react";

export const GoToOrgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.16667 0V1.66667H12.1583L3.96667 9.85833L5.14167 11.0333L13.3333 2.84167V5.83333H15V0M13.3333 13.3333H1.66667V1.66667H7.5V0H1.66667C0.741667 0 0 0.75 0 1.66667V13.3333C0 13.7754 0.175595 14.1993 0.488155 14.5118C0.800716 14.8244 1.22464 15 1.66667 15H13.3333C13.7754 15 14.1993 14.8244 14.5118 14.5118C14.8244 14.1993 15 13.7754 15 13.3333V7.5H13.3333V13.3333Z"
      fill="#8ACEFF"
    />
  </svg>
);
